import React from "react";
import { Star, Quote } from "lucide-react";

const DETAILER_IMG =
  "https://static.prod-images.emergentagent.com/jobs/a08e3a5b-1647-495d-beb7-38e04e36fd68/images/3a0da36afac35515a2a06793e332436892d2d81f6b93000233f811b4564a475e.png";

const reviews = [
  {
    name: "Marcus T.",
    car: "Porsche 911 GT3",
    text: "Booked the Ceramic Armor for my GT3. Six months later the paint still beads like day one. Worth every penny.",
  },
  {
    name: "Sofia R.",
    car: "Tesla Model S Plaid",
    text: "Came to my office, finished in 3 hours, interior smells like a brand new car. Insane attention to detail.",
  },
  {
    name: "David K.",
    car: "BMW M4 Competition",
    text: "Found micro-scratches I'd been chasing for months. Paint correction was surgical. Highly recommend.",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative bg-[#050505] py-28 md:py-36 border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-12 gap-10">
        {/* Left column: Master detailer card */}
        <div className="lg:col-span-5">
          <span className="text-blue-500 uppercase text-xs tracking-[0.3em] font-semibold mb-4 block">
            · 06 Word of mouth
          </span>
          <h2 className="font-heading text-white text-4xl md:text-5xl tracking-tighter font-light leading-tight mb-8">
            Owners who notice
            <br />
            <span className="font-medium">the small things.</span>
          </h2>
          <div className="bg-[#0a0a0c] border border-white/8 overflow-hidden">
            <div className="aspect-[4/3] overflow-hidden">
              <img src={DETAILER_IMG} alt="Master detailer" className="w-full h-full object-cover" />
            </div>
            <div className="p-6">
              <p className="text-xs uppercase tracking-[0.3em] text-blue-500 mb-2">Master Detailer</p>
              <h3 className="font-heading text-white text-2xl font-medium tracking-tight">Anton Voss</h3>
              <p className="text-zinc-500 text-sm mt-2">
                12 years in the craft. IDA certified. Personally inspects every Ceramic Armor finish.
              </p>
            </div>
          </div>
        </div>

        {/* Right column: review cards */}
        <div className="lg:col-span-7 flex flex-col gap-5">
          {reviews.map((r, i) => (
            <div
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-[#0a0a0c] border border-white/8 p-7 md:p-8 hover:border-white/20 transition-colors relative"
            >
              <Quote className="absolute top-6 right-6 text-blue-500/20" size={42} />
              <div className="flex mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} size={14} fill="#3B82F6" stroke="#3B82F6" />
                ))}
              </div>
              <p className="text-zinc-200 text-base md:text-lg leading-relaxed font-light">
                "{r.text}"
              </p>
              <div className="mt-6 pt-6 border-t border-white/5 flex items-center justify-between">
                <p className="font-heading text-white font-medium">{r.name}</p>
                <p className="text-zinc-500 text-sm">{r.car}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
